<template>
  <div class="d-flex" :class="[type]">
    <input
      ref="checkbox"
      v-if="legend.label !== allLabel"
      @change="handleCheckboxChange"
      type="checkbox"
      :id="getLabelId(legend)"
      :name="getLabelId(legend)"
      :checked="checkboxChecked"
      class="d-flex"
    />
    <input
      ref="allCheckbox"
      v-else
      @click.prevent="handleAllCheckboxChange"
      type="checkbox"
      :id="getLabelId(legend)"
      :name="getLabelId(legend)"
      :checked="isVisible"
      class="d-flex"
    />
    <label
      class="d-flex"
      :for="getLabelId(legend)"
      :style="
        'border-color:' + legend.color + ';' + 'background: ' + legend.color
      "
      ><Tooltip
        v-if="legend.isDataFromGa"
        class="ga_badge"
        :text="$t('components.legend.gaTooltip')"
        @click.prevent
      >
        <span class="ga_badge_text">GA</span>
        <img :src="CheckmarkGreenIcon" class="ga_badge_icon" />
      </Tooltip>
      <span :class="{ ga_offset: legend.isDataFromGa }">{{ legend.label }}</span></label
    >
    <a v-if="link && legend.label !== allLabel" class="link" target="_blank" :href="'//' + legend.label">
      <img :src="LinkOnSiteIcon" />
    </a>
    <button
      v-if="removeButton && legend.label !== allLabel"
      class="clear_button"
      @click="removeDomain(legend.label)"
    >
      <!-- инлайн, а не clear.svg: цвета берутся из темы -->
      <svg class="clear_icon" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <circle cx="7.5" cy="7.5" r="7.5" />
        <path d="M10 10L5 5M5 10L10 5" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</template>

<script>
import LinkOnSiteIcon from '@/assets/icons/link-on-site.svg'
import CheckmarkGreenIcon from '@/assets/icons/base/checkmark-green.svg'
import Tooltip from '@/components/shared/Tooltip.vue'

export default {
  data() {
    return {
      LinkOnSiteIcon,
      CheckmarkGreenIcon,
      localChecked: true,
      // см. комментарий в LegendDomains.vue: метка "All" фиксируется при создании
      allLabel: this.$t('components.legend.all'),
    }
  },
  props: {
    legend: Object,
    type: {
      type: String,
      default: 'checkbox',
    },
    link: {
      type: Boolean,
      default: true,
    },
    removeButton: Boolean,
    chartName: String,
    isVisible: {
      type: Boolean,
      default: true,
    },
  },
  components: { Tooltip },
  computed: {
    checkboxChecked() {
      return this.localChecked
    },
  },
  watch: {
    isVisible: {
      handler(newVal) {
        // Когда isVisible меняется для All чекбокса, принудительно обновляем его состояние
        if (this.legend.label === this.allLabel) {
          this.$nextTick(() => {
            if (this.$refs.allCheckbox) {
              this.$refs.allCheckbox.checked = newVal
            }
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Убедимся, что чекбокс All правильно инициализирован при монтировании
    if (this.legend.label === this.allLabel && this.$refs.allCheckbox) {
      this.$refs.allCheckbox.checked = this.isVisible
    }
  },
  methods: {
    handleAllCheckboxChange(event) {
      // Эмитим событие для обновления состояния в родителе
      this.$emit('updateDataset', this.legend.index)
    },
    handleCheckboxChange(event) {
      // Для обычных датасетов переключаем локальное состояние
      this.localChecked = !this.localChecked
      this.$emit('updateDataset', this.legend.index)
    },
    updateDataset(index) {
      this.$emit('updateDataset', index)
    },
    removeDomain(domain) {
      this.$emit('removeDomain', domain)
    },
    getLabelId(legend) {
      return legend.label + this.chartName
    },
  },
}
</script>

<style scoped>
.checkbox_button {
  background: var(--bg-surface-2);
  border-radius: 7px;
  padding: 6px 15px 5px;
}

input {
  margin-right: 5px;
  cursor: pointer;
}
label {
  margin: 2px;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
}
label span {
  background: var(--bg-surface);
  padding-left: 2em;
}

.checkbox_button label span {
  background: var(--bg-surface-2);
}

.domain label span {
  padding-left: 10px;
}
.link {
  display: block;
  margin-top: -6px;
}
.clear_button {
  background: none;
  margin: 0px 0px 0 4px;
  padding: 0;
}
.clear_icon circle {
  fill: var(--icon-clear-bg);
  transition: fill 0.15s ease;
}
.clear_icon path {
  stroke: var(--icon-clear-cross);
}
.clear_button:hover .clear_icon circle {
  fill: var(--text-secondary3);
}

/* бейдж не участвует в потоке, чтобы белый span продолжал перекрывать
   цветную подложку лейбла; рисуется поверх, сразу после чекбокса (20px) */
.ga_badge {
  position: absolute !important;
  left: 25px;
  top: -6px;
  margin: 0 !important;
}

/* резервируем место под бейдж между чекбоксом и именем домена */
label span.ga_offset {
  padding-left: 54px;
}

.ga_badge_text {
  font-size: 10px;
  font-weight: 600;
  color: var(--success-color-2);
  margin-right: 1px;
  /* нейтрализуем label span { padding-left: 2em; background: var(--bg-surface) } — иначе GA уезжает на имя домена */
  padding-left: 0;
  background: transparent;
}

.ga_badge_icon {
  width: 8px;
  height: 7px;
}

:v-deep(.clear_button svg) {
  margin-bottom: 1px;
}

[type='checkbox']:not(:checked),
[type='checkbox']:checked {
  opacity: 0;
  width: 0;
  height: 0;
}
[type='checkbox']:not(:checked) + label,
[type='checkbox']:checked + label {
  position: relative;
  cursor: pointer;
}

/* checkbox aspect */
[type='checkbox']:not(:checked) + label:before,
[type='checkbox']:checked + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: 1px solid;
  border-color: inherit;
  background-color: inherit;
  border-radius: 5px;
  -webkit-transition: all 0.275s;
  transition: all 0.275s;
}

[type='checkbox']:not(:checked) + label:before {
  background-color: var(--bg-surface) !important;
}

/* checked mark aspect */
[type='checkbox']:not(:checked) + label:after,
[type='checkbox']:checked + label:after {
  content: url('/checkmark.svg');
  position: absolute;
  top: 5px;
  left: 5px;
  font-size: 1.2em;
  color: white;
  line-height: 0;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

/* checked mark aspect changes */
[type='checkbox']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0) rotate(45deg);
  transform: scale(0) rotate(45deg);
}

[type='checkbox']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1) rotate(0);
  transform: scale(1) rotate(0);
}

/* Disabled checkbox */
[type='checkbox']:disabled:not(:checked) + label:before,
[type='checkbox']:disabled:checked + label:before {
  box-shadow: none;
  border-color: var(--border-color-2);
  background-color: var(--bg-surface-3);
}

[type='checkbox']:disabled:checked + label:after {
  color: var(--text-secondary3);
}

[type='checkbox']:disabled + label {
  color: var(--text-secondary3);
}
</style>
